import React from 'react';
import { Sparkles, Phone, Mail } from 'lucide-react';
import { site, services } from '../data/site';
export function Footer() {
  return <footer className="bg-[#0B1B2B] py-14 text-[#FFFDF6]" data-id="element-27" data-mp="3ggu1qsai619z">
      <div className="mx-auto w-full max-w-7xl px-5 sm:px-8" data-id="element-28" data-mp="32oe0nx15wdbp">
        <div className="grid gap-10 md:grid-cols-[1.4fr_1fr_1fr]" data-id="element-29" data-mp="32m1aiwl92wnk">
          <div data-id="element-30" data-mp="36pzatambadi7">
            <div className="flex items-center gap-2.5" data-id="element-31" data-mp="36nd4tff2k623">
              <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-[#FFD84D] text-[#0B1B2B]" data-id="element-32" data-mp="3ues8bbil0tex">
                <Sparkles className="h-5 w-5" aria-hidden="true" data-id="element-33" data-mp="37fun6gwqy3r" />
              </span>
              <span className="text-lg font-extrabold leading-none tracking-tight" data-id="element-34" data-mp="3ldan5eqbi1jd">
                Horizons
                <span className="block text-[10px] font-bold uppercase tracking-[0.22em] text-[#FFFDF6]/60" data-id="element-35" data-mp="3qc3zh3tvbmhy">
                  Window Cleaning
                </span>
              </span>
            </div>
            <p className="mt-5 max-w-sm text-base text-[#FFFDF6]/70" data-id="element-36" data-mp="2ez1nkm2prl44">
              Professional window, gutter and exterior cleaning for homes and businesses.
              Licensed, insured, and obsessive about the details.
            </p>
          </div>

          <nav aria-label="Services" data-id="element-37" data-mp="3v7gha5qpmkbx">
            <h2 className="text-xs font-extrabold uppercase tracking-[0.22em] text-[#FFD84D]" data-id="element-38" data-mp="3v8hq03k96uqh">
              Services
            </h2>
            <ul className="mt-4 space-y-2.5" data-id="element-39" data-mp="3qazrl73v3xwq">
              {services.map(service => <li key={service.id} data-id="element-40" data-mp="80xi63gl8rgz">
                  <a href="#services" className="text-base font-semibold text-[#FFFDF6]/75 underline-offset-4 hover:text-[#FFFDF6] hover:underline" data-id="element-41" data-mp="34gxxkciex96">
                    {service.title}
                  </a>
                </li>)}
            </ul>
          </nav>

          <div data-id="element-42" data-mp="qub5bme27tm1">
            <h2 className="text-xs font-extrabold uppercase tracking-[0.22em] text-[#FFD84D]" data-id="element-43" data-mp="qtrok905bb9l">
              Contact
            </h2>
            <ul className="mt-4 space-y-2.5" data-id="element-44" data-mp="tvcyrpppu1e3">
              <li data-id="element-45" data-mp="two2xqn2pb5q">
                <a href={`tel:${site.phone.replace(/[^0-9]/g, '')}`} className="flex items-center gap-2 text-base font-semibold text-[#FFFDF6]/75 hover:text-[#FFFDF6]" data-id="element-46" data-mp="tt088o5w6ipf">
                  <Phone className="h-4 w-4" aria-hidden="true" data-id="element-47" data-mp="18k0sdqg0411e" />
                  {site.phone}
                </a>
              </li>
              <li data-id="element-48" data-mp="1ckknkoh0kukw">
                <a href={`mailto:${site.email}`} className="flex items-center gap-2 text-base font-semibold text-[#FFFDF6]/75 hover:text-[#FFFDF6]" data-id="element-49" data-mp="1cl2t6bpkgl5h">
                  <Mail className="h-4 w-4" aria-hidden="true" data-id="element-50" data-mp="1mkbi2q5kr9kz" />
                  {site.email}
                </a>
              </li>
              <li className="text-base font-semibold text-[#FFFDF6]/75" data-id="element-51" data-mp="1rgiosl5sop3z">{site.hours}</li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t-2 border-[#FFFDF6]/15 pt-6 sm:flex-row sm:items-center sm:justify-between" data-id="element-52" data-mp="3t9gew986t3l8">
          <p className="text-sm font-semibold text-[#FFFDF6]/50" data-id="element-53" data-mp="2agevdmoqg595">
            © {new Date().getFullYear()} {site.name}. All rights reserved.
          </p>
          <p className="text-sm font-semibold text-[#FFFDF6]/50" data-id="element-54" data-mp="21ma9zisdbm10">
            Licensed &amp; insured · Free estimates
          </p>
        </div>
      </div>
    </footer>;
}